import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import store from "./redux/store";
import { Provider } from "react-redux";
import { EcouiProvider } from "ecologital-ui-library";
import reportWebVitals from "./reportWebVitals";
import "ecologital-ui-library/dist/ecologitalUILibrary.css";

ReactDOM.render(
  <React.StrictMode>
    <EcouiProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </EcouiProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

if (process.env.NODE_ENV !== "development") console.log = () => {};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
